// extracted by mini-css-extract-plugin
export default {"wrapper":"RenderError_wrapper__M5PWK","errorContent":"RenderError_errorContent__8fOam"};